/* F15 STEP 4.2 — THE PROGRAM PAGE'S DELOAD BLOCK: its words and its one write (`coach_programs`). The planners' rule is
 * `_shared/coachDeload.ts` (`programBlockDue`, `programVerdict`); this file only says it.
 * His 11-02 word: "just 2 options for deload. manual … or auto" — ONE pick of two, no migration: MANUAL = `deload_every`
 * NULL (the week bar's Deload switch is the only way), AUTO = `AUTO_EVERY` (proposed when the numbers fall or around week 7).
 * `deload_automatic` is always written false: Auto proposes, it never writes a deload untapped. */
import { AUTO_EVERY, isAutoBlock, type ProgramBlock } from "../../../supabase/functions/_shared/coachDeload";

export type { ProgramBlock };

/** A program with no block written reads ON and MANUAL — every program before 4.2 (and all three live ones, 11-02). */
export const BLOCK_DEFAULT: ProgramBlock = { progress: true, deloadEvery: null, automatic: false };

export type DeloadMode = "manual" | "auto";

/** The two choices, in the order the pick lists them: their words and what each one does. */
export const DELOAD_MODES: readonly { key: DeloadMode; label: string; detail: string }[] = [
  { key: "manual", label: "Manual deload", detail: "Tap Deload on the weeks you choose" },
  { key: "auto", label: "Auto deload", detail: "Proposed when the numbers fall or around week 7" },
];

export const deloadModeOf = (b: ProgramBlock): DeloadMode => (isAutoBlock(b) ? "auto" : "manual");

export function deloadModeLabel(mode: DeloadMode): string {
  return DELOAD_MODES.find((m) => m.key === mode)?.label ?? "";
}

/** The block with the other choice: its switch kept, the two deload columns the choice's own. */
export function withDeloadMode(b: ProgramBlock, mode: DeloadMode): ProgramBlock {
  return { progress: b.progress, deloadEvery: mode === "auto" ? AUTO_EVERY : null, automatic: false };
}

/** The row `coach_programs` stores, from the block (the three columns, always written together). */
export function blockColumns(b: ProgramBlock): { progress: boolean; deload_every: number | null; deload_automatic: boolean } {
  return { progress: b.progress, deload_every: b.deloadEvery, deload_automatic: b.automatic };
}

/** The block a `coach_programs` row reads as (a missing column = the default). */
export function blockOf(row: { progress?: boolean | null; deload_every?: number | null; deload_automatic?: boolean | null }):
  ProgramBlock {
  return { progress: row.progress ?? BLOCK_DEFAULT.progress, deloadEvery: row.deload_every ?? null,
           automatic: row.deload_automatic ?? BLOCK_DEFAULT.automatic };
}
